$(document).ready(function () {
  if($(".product-info-accordion .attrib-title").length > 0){
    $(".attrib-title").each(function() {
      var internal_title = $(this).html();
      if(internal_title == "Origins"){
        $(this).css("display", "block");
      }
    });
  }
  let image_row = $('td[colspan="2"]');
  if(image_row.length > 0){
    image_row.css('display','none')
  }
});